import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { ReactComponent as Upload } from "src/img/svg/upload.svg";
import { ReactComponent as Download } from "src/img/svg/download.svg";
// import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData, myAxios, projectCategoryColorCode, getDriveFolderId
} from "src/components/common/functions";
import UserForm from "./userForm";
import DispatchForm from "./dispatchForm";

const title = "Personnel";
//--------------------------------------------------------------------------------------------
export default function Detail({
    id, 
    idid, 
    setUserList, 
    userList, 
    user, 
    history, 
    deleteUser, 
    handleSubmit
}){
    const curUser = useMyStore(state => state.user);
    const handleSystemFilesInput = async (
        target, fileId
    ) => {
        const files = target.files;
        if(files.length === 0) return;
        if(fileId && !window.confirm(`Are you sure to overwrite the existing MVR of ${user.userName}?`)) return;
        const formData = new MyFormData();
        formData.append("id", fileId?fileId:"");
        formData.append("folderId", getDriveFolderId("motorVehicleRecord"));
        formData.append("key", "mvr");
        formData.append("userEmail", user.email);
        for(let file of files){
            formData.append("files[]", file);
        }
        //------------------------
        setShowLoader(true);
        const res = await myAxios("users/createAttachment.php", formData);
        setShowLoader(false);
        if(!res) return;
        //------------------------
        setUserList(userList.map(p => ({
            ...p, mvr:
            (p.email === user.email?
            res.data
            :p.mvr
            )
        })));
        target.value = "";
    }
    const deleteFile = async(fileId) => {
        if(!window.confirm(`Are you sure to delete the existing MVR of ${user.userName}?`)) return;
        const formData = new MyFormData();
        formData.append("id", fileId);
        formData.append("key", "mvr");
        formData.append("userEmail", user.email);
        //---------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("users/deleteAttachment.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------------
        setUserList(userList.map(p => ({
            ...p, mvr:
            (p.email === user.email?
            ""
            :p.mvr
            )
        })));
    }
    const [purchaseList, setPurchaseList] = useState([]);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const calendarCategory = Object.keys(projectCategoryColorCode);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //-----------------------------------
            setShowLoader(true);
            const formData = new MyFormData();
            formData.append("userEmail", user.email);
            const resPurchases = await myAxios("users/readPurchases.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resPurchases) return;
            //-----------------------------------
            setPurchaseList(resPurchases.data);
        }
        if(user.btlNumber) getData();
        return () => {isMounted = false;}
    }, [setShowLoader, user.btlNumber, user.email])
    return(
    <>
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div style = {{display: "flex"}}>
            <div className = "col-4">
                <div className = "text-center h5 font-weight-bold mt-3">Detail Information</div>
                <table className = "table table-responsive-xl">
                    <tbody>
                        {user.unionName?<tr> 
                            <th>Union</th>
                            <td>
                                <div><span className = "font-weight-bold mr-3">Name:</span>{user.unionName}</div>
                                <div className = "mt-2"><span className = "font-weight-bold mr-3">Level:</span>{user.phaseLevel}</div>
                            </td>
                        </tr>:null}
                        {user.address?<tr> 
                            <th>Address</th>
                            <td>{user.address}</td>
                        </tr>:null}
                        {user.outside !== "no"?
                        <tr>
                            <th>Outside Service</th>
                            <td>
                                <div><span className = "font-weight-bold mr-3">Job Category:</span>{user.outside}</div>
                                <div className = "mt-2"><span className = "font-weight-bold mr-3">Lan Id:</span>{user.lanId}</div>
                                <div className = "mt-2"><span className = "font-weight-bold mr-3">BTL No.:</span>{user.btlNumber}</div>
                                <div className = "mt-2"><span className = "font-weight-bold mr-3">Residence:</span>{[user.street, user.residence, user.residenceState, user.zipCode].filter(value => value).join(", ")}</div>
                            </td>
                        </tr>
                        :null}
                        <tr>
                            <th>Hire Date</th>
                            <td>{user.hireDate}</td>
                        </tr>
                        <tr>
                            <th>Quit Date</th>
                            <td>{user.quitDate?user.quitDate:""}</td>
                        </tr>

                        {curUser.personel === "yes"?<>
                        <tr>
                            <th>SSN</th>
                            <td>{user.ssn}</td>
                        </tr>
                        <tr> 
                            <th>Birthday</th>
                            <td>{user.birthDay}</td>
                        </tr>
                        <tr> 
                            <th>Driver License</th>
                            <td>{user.driverLicense}</td>
                        </tr>
                        <tr> 
                            <th>EE ID</th>
                            <td>{user.employee_id}</td>
                        </tr>
                        <tr> 
                            <th>Classification</th>
                            <td>{user.classification}</td>
                        </tr>
                        {curUser.fleets === "yes" || false?
                        <tr>
                            <th style = {{verticalAlign: "middle"}}>MVR</th>
                            <td
                                onDragOver = {e => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }}
                                onDrop = {async e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // **** create new file(s) ****
                                    handleSystemFilesInput(e.dataTransfer, user.mvr);
                                }}
                            >
                                <label htmlFor = {`uploadItemFiles ${user.email} mvr`} className = "mb-0 btn btn-primary">
                                    <Upload/>
                                </label>
                                <input 
                                    id = {`uploadItemFiles ${user.email} mvr`} 
                                    type = "file" 
                                    style = {{display: "none"}} 
                                    onChange = {e => handleSystemFilesInput(e.currentTarget, user.mvr)}
                                />
                                {user.mvr?
                                <>
                                <a
                                    id = {`getMVR ${user.email}`}
                                    className = "btn btn-success ml-3"
                                    href = {`https://drive.google.com/uc?export=download&id=${user.mvr}`}
                                    target = "_blank"
                                    rel = "noreferrer"
                                >
                                    <Download/>
                                </a>
                                {curUser.fleets === "yes"?
                                <span
                                    id = {`deleteMVR ${user.email}`}
                                    className = "btn btn-danger ml-3"
                                    onClick = {() => deleteFile(user.mvr)}
                                >
                                X
                                </span>
                                :<></>}
                                </>
                                :null}
                            </td>
                        </tr>
                        :<></>}
                        </>:null}

                        <tr> 
                            <th>Google Account</th>
                            <td>{user.googleAccount}</td>
                        </tr>

                        <tr>
                            <th>Creator</th>
                            <td>
                                <UserInfo 
                                    name = {userList.map(u => 
                                        u.email === user.creatorEmail?
                                        `${u.firstName} ${u.middleName} ${u.lastName}`:
                                        null
                                    ).filter(u => u !== null)[0]}
                                    email = {user.creatorEmail}
                                />
                                <span className = "ml-3">{user.dateCreated}</span>
                            </td>
                        </tr>
                        {user.updaterEmail?
                        <tr> 
                            <th>Updater</th>
                            <td>
                                <UserInfo 
                                    name = {userList.map(u => 
                                        u.email === user.updaterEmail?
                                        `${u.firstName} ${u.middleName} ${u.lastName}`:
                                        null
                                    ).filter(u => u !== null)[0]}
                                    email = {user.updaterEmail}
                                />
                                <span className = "ml-3">{user.dateUpdated}</span>
                            </td>
                        </tr>
                        :null}
                        {user.googleCalendar?
                        <tr> 
                            <th>Google Calendar</th>
                            <td>
                                <ul>
                                    {calendarCategory.map((value, key) =>
                                        <li key = {key} className = "my-3">{value}: {JSON.parse(user.googleCalendar)[value]?<>
                                            <span className = "font-weight-bold text-success">Yes</span>
                                            <div><span className = "btn btn-primary" onClick = {async() => {
                                                const formData = new MyFormData();
                                                formData.append("category", value);
                                                formData.append("userEmail", user.email);
                                                //-----------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("users/sendCalendarLink.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-----------------------------------
                                            }}>Send Link</span></div>
                                        </>:<span className = "font-weight-bold text-danger">No</span>}</li>
                                    )
                                    }
                                </ul>
                            </td>
                        </tr>
                        :null}
                    </tbody>
                </table>
                <div>
                    <span
                        className = "btn btn-success"
                        onClick = {e => {
                            e.currentTarget.nextElementSibling.click();
                        }}
                    >
                        Upload Profile
                    </span>
                    <input
                        className = "nodisplay"
                        type = "file"
                        accept = "image/png, image/jpeg"
                        onChange = {async e => {
                            const target = e.currentTarget;
                            if(!target.files || !target.files[0] || !target.files[0].name) return;
                            const formData = new MyFormData();
                            formData.append("userEmail", user.email);
                            formData.append("profile", target.files[0]);
                            //-----------------------------------
                            setShowLoader(true);
                            const res = await myAxios("common/updatePhoto.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //-----------------------------------
                            const reader = new FileReader();
                            reader.onload = () => {
                                setUserList(userList.map(u => u.email === user.email?{...u, thumbnail: reader.result}:u));
                            }
                            reader.readAsDataURL(target.files[0]);
                        }}
                    />
                    {user.thumbnail?
                    <span
                        className = "ml-3 btn btn-danger"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to delte this profile?")) return;
                            const formData = new MyFormData();
                            formData.append("userEmail", user.email);
                            //-----------------------------------
                            setShowLoader(true);
                            const res = await myAxios("common/deletePhoto.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //-----------------------------------
                            setUserList(userList.map(u => u.email === user.email?{...u, thumbnail: ""}:u));
                        }}
                    >
                        Delete Profile
                    </span>
                    :<></>}
                </div>
                {user.btlNumber && purchaseList.length?
                <details className = "mt-4">
                    <summary className = "h5">Related Expense</summary>
                    <ul>
                        {purchaseList.map((p, pi) => 
                        <li key = {pi}>
                            <Link
                                to = {`/Purchases/${p.poNumber}`}
                            >
                                {p.poNumber} &mdash; ${p.total}
                            </Link>
                        </li>)}
                    </ul>
                </details>
                :<></>}
            </div>
            <div className = "col-4">
            <div className = "text-center h5 font-weight-bold mt-3">Access Control</div>
                <table className = "table table-responsive-xl">
                    <tbody>
                        <tr>
                            <th>Projects</th>
                            <td>{user.projects}</td>
                        </tr>
                        <tr>
                            <th>Work Logs</th>
                            <td>{user.workLogs}</td>
                        </tr>
                        <tr>
                            <th>Purchase</th>
                            <td>{user.purchases}</td>
                        </tr>
                        <tr>
                            <th>Per Diem</th>
                            <td>{user.perDiem}</td>
                        </tr>
                        <tr>
                            <th>Newspaper</th>
                            <td>{user.newspaper}</td>
                        </tr>
                        <tr>
                            <th>Fleets</th>
                            <td>{user.fleets}</td>
                        </tr>
                        <tr>
                            <th>Reports</th>
                            <td>{user.reports}</td>
                        </tr>
                        <tr>
                            <th>{title}</th>
                            <td>{user.personel}</td>
                        </tr>
                        <tr>
                            <th>Calendar</th>
                            <td>{user.calendar}</td>
                        </tr>
                        <tr>
                            <th>Time Off</th>
                            <td>{user.dayOff}</td>
                        </tr>
                        <tr>
                            <th>Office</th>
                            <td>{user.office}</td>
                        </tr>
                        <tr>
                            <th>Office Status</th>
                            <td>{user.allOffice}</td>
                        </tr>
                        <tr>
                            <th>Outside Service</th>
                            <td>{user.outside}</td>
                        </tr>
                        <tr>
                            <th>Outside Service Timecards</th>
                            <td>{user.outsideTimeCards}</td>
                        </tr>
                        <tr>
                            <th>Outside Service Status</th>
                            <td>{user.outsideStatus}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className = "col-4">
                <fieldset className = "rounded border px-4" style = {{minHeight:"90%", whiteSpace: "pre-wrap"}}>
                    <legend className = "px-2 font-weight-bold" style = {{width:"auto"}}>Background</legend>
                    <span>{user.background}</span>
                </fieldset>
            </div>
        </div>
        <div className = "m-3 text-right">
            {curUser.personel === "yes" || (curUser.personel === "outside" && user.outside !== "no")?<>
            {user.verificationCode !== ""?
            <span className = "btn btn-info m-3" onClick = {async() => {
                const formData = new MyFormData();
                formData.append("userEmail", user.email);
                setShowLoader(true);
                const res = await myAxios("users/resendVerificationCode.php", formData);
                setShowLoader(false);
                if(!res) return;
            }}>
                Resend Verification Code
            </span>
            :<></>}
            <span className = "btn btn-primary m-3" onClick = {() => {
                history.push(`/${title}/${id}/Edit`);
            }}>
                Edit
            </span>
            {false?
            <span className = "btn btn-danger m-3" onClick = {deleteUser} id = {user.email} googlecalendar = {user.googleCalendar}>
                Delete
            </span>
            :null}
            </>:null}
            {user.dispatch === "1"?
            <span className = "btn btn-primary m-3" onClick = {() => {
                history.push(`/${title}/${id}/EditDispatch`);
            }}>
                Edit Dispatch
            </span>
            :null}
        </div>
    </div>
    {idid === "Edit"?<UserForm {...user} handleSubmit = {handleSubmit} closeIt = {() => history.push(`/${title}`)} keyword = "Edit" shouldDisable = {true} postUrl = "users/updateUser.php"/>:null}
    {idid === "EditDispatch"?<DispatchForm {...user} handleSubmit = {handleSubmit} closeIt = {() => history.push(`/${title}`)} keyword = "Edit Dispatch" shouldDisable = {true} postUrl = "users/updateUser.php"/>:null}
    </>
    )
}